/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Period_CustomInputs */

const vi_order_period_custom = /** @type {(inputs: Order_Period_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tùy chỉnh`)
};

/**

* @param {Order_Period_CustomInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_period_custom = /** @type {((inputs?: Order_Period_CustomInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Period_CustomInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_period_custom(inputs)
});